@file:OptIn(InternalResourceApi::class)

package top.features.dashboard.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/top.features.dashboard.generated.resources/"

@delegate:ResourceContentHash(-1_122_496_068)
internal val Res.drawable.img_empty_ai_moderation: DrawableResource by lazy {
      DrawableResource("drawable:img_empty_ai_moderation", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_empty_ai_moderation.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(452_265_418)
internal val Res.drawable.img_empty_comments: DrawableResource by lazy {
      DrawableResource("drawable:img_empty_comments", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_empty_comments.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_734_911_462)
internal val Res.drawable.img_empty_dashbord: DrawableResource by lazy {
      DrawableResource("drawable:img_empty_dashbord", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_empty_dashbord.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_734_911_462)
internal val Res.drawable.img_empty_statistic: DrawableResource by lazy {
      DrawableResource("drawable:img_empty_statistic", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_empty_statistic.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_247_868_479)
internal val Res.drawable.img_empty_users: DrawableResource by lazy {
      DrawableResource("drawable:img_empty_users", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_empty_users.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("img_empty_ai_moderation", Res.drawable.img_empty_ai_moderation)
  map.put("img_empty_comments", Res.drawable.img_empty_comments)
  map.put("img_empty_dashbord", Res.drawable.img_empty_dashbord)
  map.put("img_empty_statistic", Res.drawable.img_empty_statistic)
  map.put("img_empty_users", Res.drawable.img_empty_users)
}
